import { Component, OnInit } from '@angular/core';
import { LocalService } from '../../../core';

@Component({
  selector: 'app-blocked',
  templateUrl: './blocked.component.html',
  styleUrls: ['./blocked.component.scss']
})
export class BlockedComponent implements OnInit {

  ngOnInit() {
    LocalService.flush('userProfile');
  }
}
